var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.00065H2.33333M2.33333 4.00065H13M2.33333 4.00065V13.334C2.33333 13.6876 2.47381 14.0267 2.72386 14.2768C2.97391 14.5268 3.31304 14.6673 3.66667 14.6673H10.3333C10.687 14.6673 11.0261 14.5268 11.2761 14.2768C11.5262 14.0267 11.6667 13.6876 11.6667 13.334V4.00065M4.33333 4.00065V2.66732C4.33333 2.3137 4.47381 1.97456 4.72386 1.72451C4.97391 1.47446 5.31304 1.33398 5.66667 1.33398H8.33333C8.68696 1.33398 9.02609 1.47446 9.27614 1.72451C9.52619 1.97456 9.66667 2.3137 9.66667 2.66732V4.00065M5.66667 7.33398V11.334M8.33333 7.33398V11.334",
    stroke: "#D92D20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.d26f0e1c3cf5fcd6b072c621a5d05b14.svg";
export { ForwardRef as ReactComponent };